"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
/* eslint-disable func-names */
function _default(value) {
  return typeof value == 'string' && (0, _trim.default)(value).call(value).length; // eslint-disable-line
}